module.exports = __webpack_public_path__ + "static/media/star-full.a8037ef9.png";